module.exports = __webpack_public_path__ + "static/Azizul_Khair-03c40bd5a333f5a5838337352553ec07.jpeg";